export default __webpack_public_path__ + "static/BgLogo-7d7b87a1d78a5701883390c82c6138c5.svg";